import React, { useState, useEffect, useRef } from 'react';
import html2canvas from "html2canvas";
import './DeckSaveLoad.css';
import FullScreenModal from './FullScreenModal';
import { createPortal } from "react-dom";

function DeckSaveLoad({ deck, onLoadDeck, openModal, continentOptions, userInfo, reloadTrigger, setReloadTrigger, cardTypeOptions, levelOptions, sexOptions, elementOptions, subElementOptions, powerOptions }) {
  
  const [continentId, setContinentId] = useState('');
  const [deckName, setDeckName] = useState('');
  const [description, setDescription] = useState('');
  const [deckTag, setDeckTag] = useState('');
  const [hiddenFlag, setHiddenFlag] = useState('0'); // 公開状態 ('0': 公開, '1': 非公開)
  const [savedDecks, setSavedDecks] = useState([]);
  const [editingDeckId, setEditingDeckId] = useState(null);
  const [toastMessage, setToastMessage] = useState('');
  const isDeckEmpty = deck.length === 0;
  const [isOpen, setIsOpen] = useState(false);

  const [mainCardId, setMainCardId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false); // 保存 or 編集中フラグ

  const [sortKey, setSortKey] = useState('add_date'); // 初期値: 作成日
  const [sortOrder, setSortOrder] = useState('asc');  // 'asc' または 'desc'

  const [detailDeck, setDetailDeck] = useState(null);  // モーダル表示対象のデッキ
  const [detailDeckCards, setDetailDeckCards] = useState([]); // モーダル内カード
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

  const [zoomImage, setZoomImage] = useState(null);

  useEffect(() => {
    const onClickOutside = (e) => {
        if (!e.target.closest('.deck-item')) {
        setActivePanelId(null);
        }
    };
    document.addEventListener('click', onClickOutside);
    return () => document.removeEventListener('click', onClickOutside);
  }, []);

  // 全デッキ取得（旧）
/*   const fetchSavedDecks = async () => {
    const res = await fetch('http://localhost:3001/api/save_decks');
    const data = await res.json();
    setSavedDecks(data);
  }; */
  // 自分のデッキを取得（新）
/*   const fetchSavedDecks = async () => {
    const token = localStorage.getItem('token');
    fetch('http://localhost:3001/api/my_decks', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => setSavedDecks(data))
      .catch((err) => console.error('デッキ取得エラー:', err));
  }; */

  const validateDeck = (deck, continentId) => {
    const errors = [];

    // 1. 大陸チェック===========================================================================================
    // 1-1. グリフはグリフのみ
    if (continentId === "1") {
      const invalidGrifCards = deck.filter(card => card.continent_flag_grif !== "1");
      if (invalidGrifCards.length > 0) {
        const names = invalidGrifCards.map(c => c.card_name).join(', ');
        errors.push(`・グリフ以外のカードはデッキに含められません（違反カード: ${names}）`);
      }
    }

    // 1-2. モゴラはモゴラのみ
    if (continentId === "2") {
      const invalidMogoraCards = deck.filter(card => card.continent_flag_mogora !== "1");
      if (invalidMogoraCards.length > 0) {
        const names = invalidMogoraCards.map(c => c.card_name).join(', ');
        errors.push(`・モゴラ以外のカードはデッキに含められません（違反カード: ${names}）`);
      }
    }

    // 1-3. コスモはコスモのみ
    if (continentId === "3") {
      const invalidCosmoCards = deck.filter(card => card.continent_flag_cosmo !== "1");
      if (invalidCosmoCards.length > 0) {
        const names = invalidCosmoCards.map(c => c.card_name).join(', ');
        errors.push(`・コスモ以外のカードはデッキに含められません（違反カード: ${names}）`);
      }
    }

    // 1-4. メトロはメトロのみ（他編と組める軍団除く）
    if (continentId === "4") {
      const invalidMetroCards = deck.filter(card => card.not_metro_flag !== "0");
      if (invalidMetroCards.length > 0) {
        const names = invalidMetroCards.map(c => c.card_name).join(', ');
        errors.push(`・メトロ以外のカードはデッキに含められません（違反カード: ${names}）`);
      }
    }

    // 1-5. ネオスはネオスのみ
    if (continentId === "5") {
      const invalidNeosCards = deck.filter(card => card.continent_flag_neos !== "1");
      if (invalidNeosCards.length > 0) {
        const names = invalidNeosCards.map(c => c.card_name).join(', ');
        errors.push(`・ネオス以外のカードはデッキに含められません（違反カード: ${names}）`);
      }
    }

    // 2. 基本枚数チェック===========================================================================================
    // 2-1. 召喚師枚数チェック
    const summoners = deck.filter(card => card.card_type_code === 1);
    if (summoners.length !== 5) {
      errors.push(`・召喚師の枚数が5枚ではありません（現在: ${summoners.length} 枚）`);
    }

    // 2-2. ゾーン枚数チェック
    const zone = deck.filter(card => card.card_type_code !== 1 && card.card_type_code !== 8 && card.card_type_code !== 9);
    if (zone.length !== 50) {
      errors.push(`・ゾーン枚数が50枚ではありません（現在: ${zone.length} 枚）`);
    }

    // 2-3. フィールド 枚数チェック
    const field = deck.filter(card => card.card_type_code === 8);
    if (field.length > 5) {
      errors.push(`・フィールドは最大5枚までです（現在: ${field.length} 枚）`);
    }

    // 2-4. 占星術 枚数チェック
    const astrology = deck.filter(card => card.card_type_code === 9);
    const astrologyCount = astrology.length;

    if (astrologyCount !== 0 && astrologyCount !== 5) {
      errors.push(`・占星術は5枚である必要があります（現在: ${astrologyCount} 枚）`);
    }

    if (astrologyCount === 5) {
      const star = astrology.filter(card => card.element_code === 15).length;
      const moon = astrology.filter(card => card.element_code === 18).length;

      const isValidCombination =
        (star === 3 && moon === 2) ||
        (star === 2 && moon === 3);

      if (!isValidCombination) {
        errors.push(
          `・占星術は 星3枚＋月2枚 または 星2枚＋月3枚 である必要があります（現在：星 ${star} 枚 / 月 ${moon} 枚）`
        );
      }
    }

    // 2-5. フィールド/占星術 混在チェック
    if (field.length > 0 && astrology.length > 0) {
      errors.push(`・フィールドと占星術はどちらかしか入れられません`);
    }    

    // 2-6. 同一カードチェック（末尾Bを無視）
    const normalizeCardId = deck.map(card => {
      return card.card_id.replace(/[A-Z]+$/i, "");  // 末尾のアルファベットを削除
    });

    const duplicates = normalizeCardId.filter((id, index) => normalizeCardId.indexOf(id) !== index);

    if (duplicates.length > 0) {
      const uniqueDup = [...new Set(duplicates)];
      errors.push(`・同じカードが含まれています: ${uniqueDup.join(", ")}`);
    }

    // 2-7. 召喚師レベル制限チェック
    const levelCount = { '1-2': 0, '3-4': 0, '5': 0, '6': 0, '7':0 };
    summoners.forEach(card => {
      if ([0, 1, 2].includes(card.level_code)) levelCount['1-2']++;
      else if ([3, 4].includes(card.level_code)) levelCount['3-4']++;
      else if ([5].includes(card.level_code)) levelCount['5']++;
      else if ([6].includes(card.level_code)) levelCount['6']++;
      else if ([7, 8].includes(card.level_code)) levelCount['7']++;
    });

    if (levelCount['1-2'] < 1) errors.push("・レベル1～2の召喚師を1枚以上含める必要があります");
    if (levelCount['3-4'] < 1) errors.push("・レベル3～4の召喚師を1枚以上含める必要があります");
    if (levelCount['5'] > 1) errors.push("・レベル5の召喚師は1枚までです");
    if (levelCount['6'] > 1) errors.push("・レベル6の召喚師は1枚までです");
    if (levelCount['7'] > 1) errors.push("・レベル7か∞の召喚師は1枚までです");    


    // 3. 軍団チェック===========================================================================================
    const summonersCorps = deck.filter(card => card.card_type_code === 1);
    const hasCosmo = summonersCorps.some(card => card.continent_flag_cosmo === '1');
    const hasMetro = summonersCorps.some(card => card.continent_flag_metro === '1');

    // 3-1. バザズーと魔導衆でしか組めない
    const hasCorps1 = summonersCorps.some(card => card.corps_code === 1);
    if (hasCorps1) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 1 || card.card_id === 'S109' || card.card_id === 'S072'|| card.card_id === 'MS109')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に魔導衆が含まれる場合、真バザズー・バザズー・魔導衆でしか組むことは出来ません（違反カード: ${ids}）`);
      }
      const invalidSummoners2 = summonersCorps.filter(card =>
        (card.card_id === 'S109' || card.card_id === 'S072' || card.card_id === 'MS109')
      );
      if (invalidSummoners2.length < 1) {
        errors.push(`・魔導衆で組む場合、真バザズー・バザズーどちらかを入れる必要があります`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-2.影忍軍でしか組めない
    const hasCorps2 = summonersCorps.some(card => card.corps_code === 2);
    if (hasCorps2) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 2)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に影忍軍が含まれる場合、影忍軍でしか組むことは出来ません（違反カード: ${ids}）`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-3.ダークと闇外道でしか組めない
    const hasCorps3 = summonersCorps.some(card => card.corps_code === 3);
    if (hasCorps3) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 3 || card.card_id === 'S211' || card.card_id === 'MS110')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に闇外道が含まれる場合、魔神ダーク・闇外道でしか組むことは出来ません（違反カード: ${ids}）`);
      }
      const invalidSummoners2 = summonersCorps.filter(card =>
        (card.card_id === 'S211' || card.card_id === 'MS110')
      );
      if (invalidSummoners2.length < 1) {
        errors.push(`・闇外道で組む場合、魔神ダークを入れる必要があります`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-4.コジローと侍五人衆でしか組めない
    const hasCorps4 = summonersCorps.some(card => card.corps_code === 4);
    if (hasCorps4) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 4 || card.card_id === 'S135')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に侍五人衆が含まれる場合、コジロー・侍五人衆でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-5.ギルギルと貝賊団でしか組めない
    const hasCorps5 = summonersCorps.some(card => card.corps_code === 5);

    if (hasCorps5) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 5 || card.card_id === 'S198')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に貝賊団が含まれる場合、ギルギル・貝賊団でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-6.ビジターズでしか組めない（ムーンは対象外）
    const hasCorps6 = summonersCorps.some(card => card.corps_code === 6 && card.card_id !== 'S399');

    if (hasCorps6) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 6 || card.card_id === 'S369' || card.card_id === 'MS149')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師にビジターズが含まれる場合、ビジターズでしか組むことは出来ません（違反カード: ${ids}）`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-7.剣人党でしか組めない
    const hasCorps7 = summonersCorps.some(card => card.corps_code === 7);

    if (hasCorps7) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 7 || card.card_id === 'S377')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に剣人党が含まれる場合、剣人党でしか組むことは出来ません（違反カード: ${ids}）`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-8.星一族でしか組めない
    const hasCorps8 = summonersCorps.some(card => card.corps_code === 8);

    if (hasCorps8) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 8 || card.card_id === 'S368' || card.card_id === 'S385' || card.card_id === 'S399')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に星一族が含まれる場合、星一族でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-9.音師でしか組めない
    const hasCorps9 = summonersCorps.some(card => card.corps_code === 9);

    if (hasCorps9) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 9 || card.card_id === 'S409' || card.card_id === 'S415')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に音師が含まれる場合、音師でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-10.兆鬼と鬼道衆でしか組めない
    const hasCorps10 = summonersCorps.some(card => card.corps_code === 10);
    if (hasCorps10) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 10 || card.card_id === 'S367' || card.card_id === 'MS112')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に鬼道衆が含まれる場合、兆鬼・鬼道衆でしか組むことは出来ません（違反カード: ${ids}）`);
      }
      const invalidSummoners2 = summonersCorps.filter(card =>
        (card.card_id === 'S367' || card.card_id === 'MS112')
      );
      if (invalidSummoners2.length < 1) {
        errors.push(`・鬼道衆で組む場合、兆鬼を入れる必要があります`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-11.毒々連でしか組めない
    const hasCorps21 = summonersCorps.some(card => card.corps_code === 21);

    if (hasCorps21) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 21 || card.card_id === 'S286')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に毒々連が含まれる場合、毒々連でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-12.お道化師でしか組めない
    const hasCorps22 = summonersCorps.some(card => card.corps_code === 22);

    if (hasCorps22) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 22 || card.card_id === 'S299')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師にお道化師が含まれる場合、お道化師でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-13.フー太陽の仮面はレクス必須
    if (
      deck.some(card => card.card_id === 'S366') &&
      !deck.some(card => card.card_id === 'S303')
    ) {
      errors.push('・フー：太陽の仮面を入れる場合、レクス(LV6)を入れる必要があります');
    }

    // 3-14.ミリティはレクス必須
    if (
      deck.some(card => card.card_id === 'S416') &&
      !deck.some(card => card.card_id === 'S303')
    ) {
      errors.push('・ミリティを入れる場合、レクス(LV6)を入れる必要があります');
    }

    // 3-15.電導師でしか組めない
    const hasCorps23 = summonersCorps.some(card => card.corps_code === 23);

    if (hasCorps23) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 23 || card.card_id === 'MS098')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に電導師が含まれる場合、電導師でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-16.クロノヴァイスでしか組めない
    const hasCorps24 = summonersCorps.some(card => card.corps_code === 24);

    if (hasCorps24) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 24 || card.card_id === 'MS109' || card.card_id === 'MS110' || card.card_id === 'MS112')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師にクロノヴァイスが含まれる場合、クロノヴァイスでしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-17.ウェポンズでしか組めない
    const hasCorps25 = summonersCorps.some(card => card.corps_code === 25);

    if (hasCorps25) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 25)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師にウェポンズが含まれる場合、ウェポンズでしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-18.レクス軍団でしか組めない
    const hasCorps26 = summonersCorps.some(card => card.corps_code === 26);

    if (hasCorps26) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 26 || card.card_id === 'MS106' || card.card_id === 'MS177')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師にレクス軍団が含まれる場合、レクス軍団でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-19.貝獣軍団でしか組めない
    const hasCorps27 = summonersCorps.some(card => card.corps_code === 27);

    if (hasCorps27) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 27 || card.card_id === 'MS065' || card.card_id === 'MS065B' || card.card_id === 'MS070' || card.card_id === 'MS070B' || card.card_id === 'MS071' || card.card_id === 'MS071B' || card.card_id === 'MS113' || card.card_id === 'MS114' || card.card_id === 'MS150' || card.card_id === 'MS151')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に貝獣軍団が含まれる場合、貝獣軍団でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-20.字獄組でしか組めない
    const hasCorps30 = summonersCorps.some(card => card.corps_code === 30);

    if (hasCorps30) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 30)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に字獄組が含まれる場合、字獄組でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-21. 竜使いでしか組めない（大陸混在時のみ）
    const hasCorps11 = summonersCorps.some(card => card.corps_code === 11);

    if (hasCorps11 && hasCosmo && hasMetro) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 11)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・大陸混在で召喚師に竜使いが含まれる場合、竜使いでしか組むことは出来ません（違反カード: ${ids}）`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-22. 獣使いでしか組めない（大陸混在時のみ）
    const hasCorps12 = summonersCorps.some(card => card.corps_code === 12);

    if (hasCorps12 && hasCosmo && hasMetro) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 12)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・大陸混在で召喚師に獣使いが含まれる場合、獣使いでしか組むことは出来ません（違反カード: ${ids}）`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-23. 虫使いでしか組めない（大陸混在時のみ）
    const hasCorps13 = summonersCorps.some(card => card.corps_code === 13);

    if (hasCorps13 && hasCosmo && hasMetro) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 13)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・大陸混在で召喚師に虫使いが含まれる場合、虫使いでしか組むことは出来ません（違反カード: ${ids}）`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-24. 魚使いでしか組めない（大陸混在時のみ）
    const hasCorps14 = summonersCorps.some(card => card.corps_code === 14);

    if (hasCorps14 && hasCosmo && hasMetro) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 14)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・大陸混在で召喚師に魚使いが含まれる場合、魚使いでしか組むことは出来ません（違反カード: ${ids}）`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }

    // 3-25. 鳥使いでしか組めない（大陸混在時のみ）
    const hasCorps15 = summonersCorps.some(card => card.corps_code === 15);

    if (hasCorps15 && hasCosmo && hasMetro) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 15)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・大陸混在で召喚師に鳥使いが含まれる場合、鳥使いでしか組むことは出来ません（違反カード: ${ids}）`);
      }
      // メトロデッキの場合、メトロの召喚師が1枚以上必須
      if (continentId === "4" && !hasMetro) {
        errors.push('・メトロ編で組む場合、メトロ編の召喚師を1枚以上含める必要があります');
      }
    }    

    // 3-26.龍之守護者でしか組めない
    const hasCorps33 = summonersCorps.some(card => card.corps_code === 33);

    if (hasCorps33) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 33 || card.card_id === 'NS067' || card.card_id === 'NS078')
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に龍之守護者が含まれる場合、龍之守護者でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-27.魔神帝團でしか組めない
    const hasCorps34 = summonersCorps.some(card => card.corps_code === 34);

    if (hasCorps34) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 34)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に魔神帝團が含まれる場合、魔神帝團でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 3-28.占星術師でしか組めない
    const hasCorps40 = summonersCorps.some(card => card.corps_code === 40);

    if (hasCorps40) {
      const invalidSummoners = summonersCorps.filter(card =>
        !(card.corps_code === 40)
      );
      if (invalidSummoners.length > 0) {
        const ids = invalidSummoners.map(c => c.card_name).join(', ');
        errors.push(`・召喚師に占星術師が含まれる場合、占星術師でしか組むことは出来ません（違反カード: ${ids}）`);
      }
    }

    // 4. 枚数制限チェック（共通）===========================================================================================
    // 4-1. 100パワーの(竜)カードは5枚まで
    const limitedElementPowerCount = deck.filter(card =>
      card.sub_element_code === 107 && card.power_code === 10
      || card.card_id === '273'
    ).length;

    if (limitedElementPowerCount > 5) {
      errors.push(
        `・100パワーの(竜)カードは合計5枚までです（現在: ${limitedElementPowerCount} 枚）`
      );
    }

    // 4-2. 同パワーのカードはそれぞれ12枚まで
    const powerCounts = deck.reduce((acc, card) => {
      const p = Number(card.power_code);
      if (p >= 1 && p <= 13) {
        acc[p] = (acc[p] || 0) + 1;
      }
      return acc;
    }, {});

    for (const [power, count] of Object.entries(powerCounts)) {
      if (count > 12) {
        errors.push(`・同パワー(${power*10})のカードは12枚までです（現在: ${count} 枚）`);
      }
    }

    // 4-3. SP封じは2枚まで
    const limitedsealedCount = deck.filter(card =>
      card.sub_element_code === 101
    ).length;

    if (limitedsealedCount > 2) {
      errors.push(
        `・SP封じは2枚までです（現在: ${limitedsealedCount} 枚）`
      );
    }

    // 4-4. 天災は1枚まで
    const limitedCardIdsDisaster = ["167", "699", "533", "641", "971", "M216", "N200"]; // 制限対象カードID
    const totalLimitedCountDisaster = deck.filter(card =>
      limitedCardIdsDisaster.includes(card.card_id)
    ).length;

    if (totalLimitedCountDisaster > 1) {
      errors.push(`・天災は1枚までです（現在: ${totalLimitedCountDisaster} 枚）`);
    }

    // 4-5. 悪魔の所業は1枚まで
    const limitedCardIdsDevil = ["163", "521", "965", "966", "967", "M225", "N208"]; // 制限対象カードID
    const totalLimitedCountDevil = deck.filter(card =>
      limitedCardIdsDevil.includes(card.card_id)
    ).length;

    if (totalLimitedCountDevil > 1) {
      errors.push(`・悪魔の所業は1枚までです（現在: ${totalLimitedCountDevil} 枚）`);
    }

    // 4-6. 天の奇跡は1枚まで
    const limitedCardIdsAngel = ["159", "528", "963", "964", "M224", "N207"]; // 制限対象カードID
    const totalLimitedCountAngel = deck.filter(card =>
      limitedCardIdsAngel.includes(card.card_id)
    ).length;

    if (totalLimitedCountAngel > 1) {
      errors.push(`・天の奇跡は1枚までです（現在: ${totalLimitedCountAngel} 枚）`);
    }

    // 4-7. 送還は1枚まで
    const limitedCardIdsGraveyard = ["164", "267", "523", "959", "987", "M226", "N202"]; // 制限対象カードID
    const totalLimitedCountGraveyard = deck.filter(card =>
      limitedCardIdsGraveyard.includes(card.card_id)
    ).length;

    if (totalLimitedCountGraveyard > 1) {
      errors.push(`・送還は1枚までです（現在: ${totalLimitedCountGraveyard} 枚）`);
    }

    // 4-8. チェンジ(同族交換)は1枚まで
    const limitedCardIdsChenge = ["161", "989", "M227", "N204"]; // 制限対象カードID
    const totalLimitedCountChenge = deck.filter(card =>
      limitedCardIdsChenge.includes(card.card_id)
    ).length;

    if (totalLimitedCountChenge > 1) {
      errors.push(`・チェンジ(同族交換)は1枚までです（現在: ${totalLimitedCountChenge} 枚）`);
    }

    // 4-9. チェンジ(属性無視)は1枚まで
    const limitedCardIdsChengeAll = ["162", "524", "958", "M230", "N205"]; // 制限対象カードID
    const totalLimitedCountChengeAll = deck.filter(card =>
      limitedCardIdsChengeAll.includes(card.card_id)
    ).length;

    if (totalLimitedCountChengeAll > 1) {
      errors.push(`・チェンジ(属性無視)は1枚までです（現在: ${totalLimitedCountChengeAll} 枚）`);
    }    

    // 5. 枚数制限チェック（大陸別）===========================================================================================
    // 5-1. （グリフ）ブロックマン、神の障壁は合計3枚まで
    const limitedCardIdsBlock1 = ["116", "170", "171", "235"]; // 制限対象カードID
    const totalLimitedCountBlock1 = deck.filter(card =>
      limitedCardIdsBlock1.includes(card.card_id)
    ).length;

    if (totalLimitedCountBlock1 > 3) {
      errors.push(`・ブロックマン、神の障壁はあわせて3枚までです（現在: ${totalLimitedCountBlock1} 枚）`);
    }

    // 5-2. （モゴラ）ブロックマン、魔神の障壁は合計3枚まで
    const limitedCardIdsBlock2 = ["531", "532", "482"]; // 制限対象カードID
    const totalLimitedCountBlock2 = deck.filter(card =>
      limitedCardIdsBlock2.includes(card.card_id)
    ).length;

    if (totalLimitedCountBlock2 > 3) {
      errors.push(`・ブロックマン、魔神の障壁はあわせて3枚までです（現在: ${totalLimitedCountBlock2} 枚）`);
    }

    // 5-3. （コスモ）ガーダー、銀河の障壁は合計3枚まで
    const limitedCardIdsBlock3 = ["645", "868", "869", "1065", "969", "970"]; // 制限対象カードID
    const totalLimitedCountBlock3 = deck.filter(card =>
      limitedCardIdsBlock3.includes(card.card_id)
    ).length;

    if (totalLimitedCountBlock3 > 3) {
      errors.push(`・ガーダー、銀河の障壁はあわせて3枚までです（現在: ${totalLimitedCountBlock3} 枚）`);
    }

    // 5-4. （メトロ）電磁の塔、ウォール、ブロックマンは合計3枚まで
    const limitedCardIdsBlock4 = ["M218", "M219", "M307", "M305", "M203"]; // 制限対象カードID
    const totalLimitedCountBlock4 = deck.filter(card =>
      limitedCardIdsBlock4.includes(card.card_id)
    ).length;

    if (totalLimitedCountBlock4 > 3) {
      errors.push(`・電磁の塔、ウォール、ブロックマンはあわせて3枚までです（現在: ${totalLimitedCountBlock4} 枚）`);
    }

    // 5-5. （ネオス）障壁は合計2枚まで
    const limitedCardIdsBlock5 = ["N198", "N199", "N340"]; // 制限対象カードID
    const totalLimitedCountBlock5 = deck.filter(card =>
      limitedCardIdsBlock5.includes(card.card_id)
    ).length;

    if (totalLimitedCountBlock5 > 2) {
      errors.push(`・神兵、除去獸渣里巴利加はあわせて2枚までです（現在: ${totalLimitedCountBlock5} 枚）`);
    }

    return errors;
  };




  const fetchSavedDecks = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/my_decks', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();

      if (Array.isArray(data)) {
        setSavedDecks(data);
      } else if (data.error === "token expired") {
        alert("セッションが切れました。再ログインしてください。");
        setSavedDecks([]);
        localStorage.removeItem("token");
      } else {
        console.warn("API が配列ではありません", data);
        setSavedDecks([]);
      }
    } catch (err) {
      console.error("デッキ取得エラー:", err);
      setSavedDecks([]);
    }
  };

  useEffect(() => {
    fetchSavedDecks();
  }, [reloadTrigger]);

  const sortedDecks = [...savedDecks].sort((a, b) => {
    let valA = a[sortKey];
    let valB = b[sortKey];

    // 数値 or 文字列判定
    if (sortKey === 'add_date' || sortKey === 'update_date') {
      valA = new Date(valA);
      valB = new Date(valB);
    } else {
      valA = (valA ?? '').toString().toLowerCase();
      valB = (valB ?? '').toString().toLowerCase();
    }

    if (valA < valB) return sortOrder === 'asc' ? -1 : 1;
    if (valA > valB) return sortOrder === 'asc' ? 1 : -1;
    return 0;
  });

  const showToast = (msg) => {
    setToastMessage(msg);
    setTimeout(() => setToastMessage(''), 3000);
  };

  const handleCreate = async () => {
    if (!deckName.trim()) return alert('デッキ名を入力してください');
    if (isDeckEmpty) return alert('カードが1枚も登録されていません');
    const res = await fetch('/api/save_decks', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userInfo.user_id,
        continent_id: continentId,
        deck_name: deckName,
        description,
        deck_tag: deckTag,
        main_card_id: mainCardId,
        hidden_flag: hiddenFlag,
        cards: deck.map(card => card.card_id)
      })
    });

    if (res.ok) {
      showToast('デッキを保存しました');
      fetchSavedDecks();
      resetForm();
    } else {
      alert('保存に失敗しました');
    }
  };

  const handleUpdate = async () => {
    if (!editingDeckId) return;
    if (!deckName.trim()) return alert('デッキ名を入力してください');
    if (isDeckEmpty) return alert('カードが1枚も登録されていません');
    if (!window.confirm('デッキ内容を更新しますか？')) return;

    const res = await fetch(`/api/save_decks/${editingDeckId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: userInfo.user_id,
        continent_id: continentId,
        deck_name: deckName,
        description,
        deck_tag: deckTag,
        main_card_id: mainCardId,
        hidden_flag: hiddenFlag,
        cards: deck.map(card => card.card_id)
      })
    });

    if (res.ok) {
      showToast('デッキを更新しました');
      fetchSavedDecks();
      resetForm();
    } else {
      alert('更新に失敗しました');
    }
  };

  const handleEdit = async (deck) => {
    const res = await fetch(`/api/save_decks/${deck.deck_id}`);
    const data = await res.json();
    if (data.cards) {
      onLoadDeck(data.cards);
      setContinentId(deck.continent_id);
      setDeckName(deck.deck_name);
      setDescription(deck.description);
      setDeckTag(deck.deck_tag || '');
      setMainCardId(deck.main_card_img || null);
      setHiddenFlag(deck.hidden_flag);
      setEditingDeckId(deck.deck_id);
    }
  };

  const handleDelete = async (deckId) => {
    if (!window.confirm('このデッキを削除しますか？')) return;

    const res = await fetch(`/api/save_decks/${deckId}`, {
      method: 'DELETE'
    });

    if (res.ok) {
      showToast('削除しました');
      fetchSavedDecks();
      if (editingDeckId === deckId) resetForm();
    } else {
      alert('削除に失敗しました');
    }
  };

  const handleLoad = async (deckId) => {
    const res = await fetch(`/api/save_decks/${deckId}`);
    const data = await res.json();
    if (data.cards) {
      onLoadDeck(data.cards);
    }
  };

  const resetForm = () => {
    setContinentId('');
    setDeckName('');
    setDescription('');
    setDeckTag('');
    setHiddenFlag('0');
    setEditingDeckId(null);
  };

  const onClickSave = () => {
    if (!deckName.trim()) return alert('デッキ名を入力してください');
    if (isDeckEmpty) return alert('カードが1枚も登録されていません');
    setIsSaving(true);
    openModal((selectedMainCardId) => {
        if (editingDeckId) {
        handleUpdateConfirmed(selectedMainCardId);
        } else {
        handleCreateConfirmed(selectedMainCardId);
        }
        setIsSaving(false);
    });
  };

  const onConfirmMain = async () => {
    if (!mainCardId) {
        alert('代表カードを選択してください');
        return;
    }
    setIsModalOpen(false);
    if (isSaving) {
        if (editingDeckId) {
        await handleUpdateConfirmed();
        } else {
        await handleCreateConfirmed();
        }
        setIsSaving(false);
    }
  };

const handleCreateConfirmed = async (selectedMainCardId) => {
  if (!continentId.trim()) return alert('大陸を選択してください');
  if (!deckName.trim()) return alert('デッキ名を入力してください');
  if (isDeckEmpty) return alert('カードが1枚も登録されていません');
  const res = await fetch('/api/save_decks', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      user_id: userInfo.user_id,
      continent_id: continentId,
      deck_name: deckName,
      description,
      deck_tag: deckTag,
      hidden_flag: hiddenFlag,
      cards: deck.map(card => card.card_id),
      main_card_id: selectedMainCardId // ← 追加
    })
  });

  if (res.ok) {
    setReloadTrigger(t => t + 1);
    showToast('デッキを保存しました');
    fetchSavedDecks();
    resetForm();
  } else {
    alert('保存に失敗しました');
  }
};

const handleUpdateConfirmed = async (selectedMainCardId) => {
  if (!editingDeckId) return;
  if (!deckName.trim()) return alert('デッキ名を入力してください');
  if (isDeckEmpty) return alert('カードが1枚も登録されていません');
  if (!window.confirm('デッキ内容を更新しますか？')) return;
  const res = await fetch(`/api/save_decks/${editingDeckId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      user_id: userInfo.user_id,
      continent_id: continentId,
      deck_name: deckName,
      description,
      deck_tag: deckTag,
      hidden_flag: hiddenFlag,
      cards: deck.map(card => card.card_id),
      main_card_id: selectedMainCardId // ← 追加
    })
  });

  if (res.ok) {
    setReloadTrigger(t => t + 1);
    showToast('デッキを更新しました');
    fetchSavedDecks();
    resetForm();
  } else {
    alert('更新に失敗しました');
  }
};


  const [activePanelId, setActivePanelId] = useState(null);

  const togglePanel = (deckId) => {
    setActivePanelId(prev => (prev === deckId ? null : deckId));
  };

  const fetchDeckDetails = async (deckId) => {
    const res = await fetch(`/api/save_decks/${deckId}`);
    const data = await res.json();
    setDetailDeck(data.deck);
    setDetailDeckCards(data.cards);
    setIsDetailModalOpen(true);
  };

  // サマリー用
  const [sortPattern, setSortPattern] = useState("element");

  // 任意の項目を集計する汎用関数
  const countByKey = (deck, key) => {
    return deck.reduce((acc, card) => {
      const value = card[key];
      if (value != null) {
        acc[value] = (acc[value] || 0) + 1;
      }
      return acc;
    }, {});
  };

  const getLabel = (options, codeKey, labelKey, value) => {
    const found = options.find(o => String(o[codeKey]) === String(value));
    return found ? found[labelKey] : "(不明)";
  };

  // ソート関数
  const sortMainDeck = (cards) => {
    const getSortKey = (card, key) => card[key] ?? '';

    const compare = (a, b, keys) => {
      for (const key of keys) {
        const valA = a[key];
        const valB = b[key];
        // null/undefined を後ろに回す
        if (valA == null && valB != null) return 1;
        if (valA != null && valB == null) return -1;
        if (valA == null && valB == null) continue;
        // 通常の比較（数値と文字列の両方に対応）
        const diff = valA.toString().localeCompare(valB.toString(), undefined, { numeric: true });
        if (diff !== 0) return diff;
      }
      return 0;
    };

    if (sortPattern === 'element') {
      return [...cards].sort((a, b) => compare(a, b, ['card_type_code', 'element_code', 'power_code']));
    } else if (sortPattern === 'power') {
      return [...cards].sort((a, b) => compare(a, b, ['card_type_code', 'power_code', 'element_code']));
    } else if (sortPattern === 'subelement') {
      return [...cards].sort((a, b) => compare(a, b, ['card_type_code', 'sub_element_code', 'element_code', 'power_code']));
    } else if (sortPattern === 'cardno') {
      return [...cards].sort((a, b) => compare(a, b, ['card_id']));
    }
    return cards;
  };

  const modalRef = useRef(null);

  //画像保存
  const saveAsImage = async () => {
    if (!modalRef.current) return;

    const canvas = await html2canvas(modalRef.current, {
      scale: 3,          // 解像度を高める
      useCORS: true,     // 画像が外部の場合でも読み込む
      scrollY: -window.scrollY, // ページスクロールを補正
      windowWidth: document.body.scrollWidth, // 横幅もフルでキャプチャ
    });
    const dataURL = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = dataURL;
    link.download = `${detailDeck.deck_name}.png`;
    link.click();
  };

  return (
    <div className={`deck-save-load ${editingDeckId ? 'editing' : ''}`}>

      <button className="toggle-button" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? '▲ デッキ管理を非表示' : '▼ デッキ管理を表示'}
      </button>
      
      <div className={`deck-save-load-body ${isOpen ? 'is-open' : ''}`}>

        <h3>デッキ管理</h3>
        {/* ✅ 大陸ドロップダウン */}
        <select
          value={continentId}
          onChange={(e) => setContinentId(e.target.value)}
        >
          <option value="">大陸を選択</option>
          {continentOptions.map(cont => (
            <option key={cont.continent_id} value={cont.continent_id}>
              {cont.continent_name}
            </option>
          ))}
        </select>
        <input
            type="text"
            value={deckName}
            onChange={(e) => setDeckName(e.target.value)}
            placeholder="デッキ名（必須入力）"
        />
        <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="説明"
        />
        <input
            type="text"
            value={deckTag}
            onChange={(e) => setDeckTag(e.target.value)}
            placeholder="タグ（例: 20ハリ, ○○軍団）"
        />
        <div className="checkbox-row">
            <label className="checkbox-label">
                <input
                type="checkbox"
                checked={hiddenFlag === '1'}
                onChange={(e) => setHiddenFlag(e.target.checked ? '1' : '0')}
                />
                非公開にする
            </label>
        </div>

        <div>
          <button className="deck-check-button" onClick={() => {
            const continentIdStr = String(continentId ?? "").trim();

            if (!continentIdStr) return alert('大陸を選択してください');
            const errors = validateDeck(deck, continentIdStr);
            if (errors.length > 0) {
              alert("以下のルールに違反しています:\n\n" + errors.join("\n"));
            } else {
              alert("デッキはルール通り組めています！");
            }
          }}>
            デッキチェック
          </button>
        </div>

        <div className="button-group">
            <button
            className="button-save"
            onClick={() => {
              if (hiddenFlag === '0') {
                if (!continentId.trim()) return alert('大陸を選択してください');
                  const errors = validateDeck(deck, continentId);
                if (errors.length > 0) {
                  return alert("デッキを公開できません。以下のルールに違反しています:\n\n" + errors.join("\n"));
                }
              }
              onClickSave();
            }}
            disabled={editingDeckId || deckName.trim() === ''}
            >
            新規デッキとして保存
            </button>
            {editingDeckId && (
            <>
                <button className="button-update" onClick={onClickSave}>デッキ編集完了</button>
                <button className="button-cancel" onClick={resetForm}>デッキ編集をキャンセル</button>
            </>
            )}
        </div>

        <div className="deck-header">
          <h4>保存済みデッキ</h4>
          <div className="sort-controls">
            <label>
              <select value={sortKey} onChange={(e) => setSortKey(e.target.value)}>
                <option value="continent_id">大陸</option>
                <option value="deck_name">デッキ名</option>
                <option value="add_date">作成日</option>
                <option value="update_date">更新日</option>
              </select>
            </label>
            <button onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}>
              {sortOrder === 'asc' ? '昇順 ▲' : '降順 ▼'}
            </button>
          </div>
        </div>

        <ul className="deck-list">
            {sortedDecks.map(deck => {
              const continent = continentOptions.find(c => c.continent_id === deck.continent_id);
              return(
                <li key={deck.deck_id} className="deck-item">
                <div
                    className="deck-name clickable"
                    onClick={() => togglePanel(deck.deck_id)}
                >
                    {/* ✅ 大陸名を表示 */}
                    {continent && (
                      <span className="continent-name-text">{continent.continent_name}</span>
                    )}
                    <img
                      src={`${process.env.PUBLIC_URL}/assets/${deck.main_card_image}`}
                      alt={deck.deck_name}
                      title={deck.deck_name}
                      className="deck-main-card"
                      style={{ width: 70 }}
                    />
                    <span className="deck-name-text">{deck.deck_name}</span>
                    {deck.deck_tag && <span className="deck-tag">（{deck.deck_tag}）</span>}
                    {deck.hidden_flag === '1' && (
                      <span className="deck-hidden">非公開</span>
                    )}
                </div>

                {activePanelId === deck.deck_id && (
                    <div className="deck-panel">
                    <button
                        className="button-detail"
                        onClick={() => fetchDeckDetails(deck.deck_id)}
                        disabled={editingDeckId}
                    >
                        デッキ詳細
                    </button>
                    <button
                        className="button-load"
                        onClick={() => handleLoad(deck.deck_id)}
                        disabled={editingDeckId}
                    >
                        デッキ読み込み
                    </button>
                    <button
                        className="button-edit"
                        onClick={() => handleEdit(deck)}
                        disabled={editingDeckId}
                    >
                        デッキを読み込んで編集
                    </button>
                    <button
                        className="button-delete"
                        onClick={() => handleDelete(deck.deck_id)}
                        disabled={editingDeckId}
                    >
                        デッキを削除
                    </button>
                    </div>
                )}
                </li>
            )})}
        </ul>
        {toastMessage && <div className="toast">{toastMessage}</div>}

        {isModalOpen && (
            <div className="modal-overlay">
                <div className="modal-content">
                <h3>代表カードを選択</h3>
                <div className="card-list-main">
                    {deck.map(card => (
                    <div
                        key={card.card_id}
                        className={`card-option ${mainCardId === card.card_id ? 'selected' : ''}`}
                        onClick={() => setMainCardId(card.card_id)}
                    >
                        <img src={`${process.env.PUBLIC_URL}/assets/${card.card_image}`} alt={card.card_name} title={card.card_name} style={{ width: 60 }} />
                    </div>
                    ))}
                </div>
                <div className="modal-buttons">
                    <button onClick={onConfirmMain} disabled={!mainCardId}>確定</button>
                    <button onClick={() => {
                        setIsModalOpen(false);

                    }}>
                      キャンセル
                    </button>
                </div>
                </div>
            </div>
        )}

        {isDetailModalOpen && detailDeck && (
          <FullScreenModal
            isOpen={isDetailModalOpen}
            onClose={() => setIsDetailModalOpen(false)}
          >
            <div ref={modalRef} className="capture-target">
              <div className="modal-header-row">
                  <h2 className="modal-title">{detailDeck.deck_name}</h2>
                  <button className="image-button" onClick={saveAsImage}>画像として保存</button>
              </div>
              <p><strong>作成者：</strong> {detailDeck.user_name}</p>
              <p><strong>タグ：</strong> {detailDeck.deck_tag || "(なし)"}</p>
              <p><strong>説明：</strong> {detailDeck.description || "(なし)"}</p>

              {/* ▼▼ サマリー ▼▼ */}
              <div className="deck-summary-grid">
                  {[
                  { title: 'カード分類', key: 'card_type_code', options: cardTypeOptions, codeKey: 'card_type_code', labelKey: 'card_type_name' },
                  { title: '召喚師レベル', key: 'level_code', options: levelOptions, codeKey: 'level_code', labelKey: 'level' },
                  { title: '性別', key: 'sex_code', options: sexOptions, codeKey: 'sex_code', labelKey: 'sex' },
                  { title: '属性', key: 'element_code', options: elementOptions, codeKey: 'element_code', labelKey: 'element_name', onlyTypeCode2: true },
                  { title: 'サブ属性', key: 'sub_element_code', options: subElementOptions, codeKey: 'element_code', labelKey: 'element_name' },
                  { title: 'パワー', key: 'power_code', options: powerOptions, codeKey: 'power_code', labelKey: 'power' },
                  ].map(({ title, key, options, codeKey, labelKey, onlyTypeCode2 }) => {
                  const targetDeck = onlyTypeCode2
                      ? detailDeckCards.filter(card => card.card_type_code === 2)
                      : detailDeckCards;

                  const counts = countByKey(targetDeck, key);
                  if (Object.keys(counts).length === 0) return null;

                  return (
                      <div className="summary-category" key={key}>
                      <h4>{title}</h4>
                      <div className="summary-items">
                          {Object.entries(counts)
                          .sort(([a], [b]) => a - b)
                          .map(([code, count]) => (
                              <div key={code} className="summary-item">
                              <span className="item-label">
                                  {getLabel(options, codeKey, labelKey, code)}
                              </span>
                              <span className="item-count">{count}</span>
                              </div>
                          ))}
                      </div>
                      </div>
                  );
                  })}
              </div>

              {/* ▼▼ ソート選択 ▼▼ */}
              <div className="sort-selector">
                  <label>ゾーン並び順:</label>
                  <select value={sortPattern} onChange={(e) => setSortPattern(e.target.value)}>
                  <option value="element">属性</option>
                  <option value="power">パワー</option>
                  <option value="subelement">サブ属性</option>
                  <option value="cardno">カードNo.</option>
                  </select>
              </div>

              {/* ▼▼ 召喚師 ▼▼ */}
              {detailDeckCards.some(card => card.card_type_code === 1) && (
                  <>
                  <ul className="deck-list">
                      {detailDeckCards
                      .filter(card => card.card_type_code === 1)
                      .sort((a, b) =>
                          a.level_code !== b.level_code
                          ? a.level_code - b.level_code
                          : a.card_id.localeCompare(b.card_id)
                      )
                      .map((card, index) => (
                          <li key={`type1-${index}`}>
                          <img
                            className="public-list-card-image"
                            src={`${process.env.PUBLIC_URL}/assets/${card.card_image}`}
                            title={card.card_name}
                            onClick={(e) => {
                              e.stopPropagation(); // ← 親クリック防止
                              setZoomImage(`${process.env.PUBLIC_URL}/assets/${card.card_image}`);
                            }}
                          />
                          </li>
                      ))}
                  </ul>
                  </>
              )}

              {/* ▼▼ フィールド or 占星術 ▼▼ */}
              {detailDeckCards.some(card => card.card_type_code === 8 || card.card_type_code === 9) && (
                  <>
                  <ul className="deck-list">
                      {detailDeckCards
                      .filter(card => card.card_type_code === 8 || card.card_type_code === 9)
                      .sort((a, b) =>
                        a.card_id.localeCompare(b.card_id)
                      )
                      .map((card, index) => (
                          <li key={`type1-${index}`}>
                          <img
                            className="public-list-card-image"
                            src={`${process.env.PUBLIC_URL}/assets/${card.card_image}`}
                            title={card.card_name}
                            onClick={(e) => {
                              e.stopPropagation(); // ← 親クリック防止
                              setZoomImage(`${process.env.PUBLIC_URL}/assets/${card.card_image}`);
                            }}
                          />
                          </li>
                      ))}
                  </ul>
                  </>
              )}

              {/* ▼▼ メインデッキ ▼▼ */}
              <ul className="deck-list">
                  {sortMainDeck(detailDeckCards.filter(card => card.card_type_code !== 1 && card.card_type_code !== 8 && card.card_type_code !== 9)).map((card, index) => (
                  <li key={index}>
                      <img
                        className="public-list-card-image"
                        src={`${process.env.PUBLIC_URL}/assets/${card.card_image}`}
                        title={card.card_name}
                        onClick={(e) => {
                          e.stopPropagation(); // ← 親クリック防止
                          setZoomImage(`${process.env.PUBLIC_URL}/assets/${card.card_image}`);
                        }}
                      />
                  </li>
                  ))}
              </ul>
            </div>
          </FullScreenModal>
        )}

      </div>
      {zoomImage &&
        createPortal(
          <div className="zoom-overlay" onClick={() => setZoomImage(null)}>
            <img
              src={zoomImage}
              className="zoom-image"
              onClick={(e) => e.stopPropagation()}
            />
          </div>,
          document.body
        )
      }
    </div>
    
  );
}

export default DeckSaveLoad;
